<div [ngClass]="customStyles()">
	<p class="font-semibold">Related Subjects:</p>
	<div #container class="relative grid items-center mt-3 h-14">
		<div
			class="bg-white hidden sm:inline-block absolute left-0 z-10 rounded-r-lg h-10 mb-3.5"
		>
			@if (displayLeftButton()) {
				<button
					class="px-5 h-full py-2.5 border border-gray-300 rounded-lg"
					(click)="onClick('left')"
				>
					<uc-arrow-left-svg></uc-arrow-left-svg>
				</button>
			}
		</div>
		<div
			#content
			class="absolute inset-0 flex items-center h-full px-5 pb-4 -mx-5 overflow-x-auto rounded-lg overflow-no-scrollbar sm:mx-0 sm:px-0 scroll-smooth"
			(scroll)="onScroll($event)"
		>
			<ng-content></ng-content>
		</div>
		<div
			class="bg-white hidden sm:inline-block absolute right-0 z-10 rounded-l-lg h-10 mb-3.5"
		>
			@if (displayRightButton()) {
				<button
					class="px-5 h-full py-2.5 border border-gray-300 rounded-lg"
					(click)="onClick('right')"
				>
					<uc-arrow-right-svg></uc-arrow-right-svg>
				</button>
			}
		</div>
	</div>
</div>
